import styled from 'styled-components'

export const Item = styled.div<{ padding?: string }>`
  display: flex;
  justify-content: space-between;
  padding: ${props => props.padding || '16px 0'};
`
